import {Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import { shareReplay } from 'rxjs/operators';
import { ServiceCategory } from './service-category.ResponseModel';
import { BuildingDescription } from './building-description-reponse-model';

@Injectable({
  providedIn: 'root'
})

export class MasterdataService {

  baseurl = environment.baseUrlCodeTable;
  // create an observable from the response of the httpclient and share this fetch with all subscribers
  // since we only want to get this data once
  amenities$ = this.httpClient.get<ServiceCategory[]>(this.baseurl + '/ServiceCategories').pipe(shareReplay(1));
  buildingdescriptions$ = this.httpClient.get<any>(this.baseurl + '/BuildingDescriptionTypes?regYear=' + 2020).
   pipe(shareReplay(1));
  bldReasonForReg$ = this.httpClient.get(this.baseurl + '/BuildingRegistrationReasonTypes').pipe(shareReplay(1));
  reasonForUpdateReg$ = this.httpClient.get(this.baseurl + '/RegUpdateReasons');
  rentReasonTypes$ = this.httpClient.get<BuildingDescription[]>(this.baseurl + '/RentDifferenceReasonTypes').pipe(shareReplay(1));
  marketRateTypes$ = this.httpClient.get(this.baseurl + '/marketrateunittypes').pipe(shareReplay(1));
  reasonsForDescription = [];

  constructor(private httpClient: HttpClient) {}
// get reason for registration.
  getDocumentTypes() {
    return this.httpClient.get(this.baseurl + '/DocumentTypes');
  }

  setReasonsForDescription(reasons) {
    reasons.forEach(reason => {
      this.reasonsForDescription[reason.code] = reason.description;
    });
  }

  getReasonsForDescription() {
    return this.reasonsForDescription;
  }

  getReasonforRegistration() {
    return this.httpClient.get(this.baseurl + '/BuildingRegistrationReasonTypes').pipe(shareReplay(1));
  }

  getBuildingDescriptionTypes(year) {
    return this.httpClient.get(this.baseurl + '/BuildingDescriptionTypes?regYear=' + year).pipe(shareReplay(1));
  }

  getApartmentInitialRegistrationReasonTypes(year) {
    return this.httpClient.get<any>(this.baseurl + '/ApartmentInitialRegistrationReasonTypes?regYear=' + year).pipe(shareReplay(1));
  }

  getInitialRegistrationStatusTypes(year) {
    return this.httpClient.get(this.baseurl + '/InitialRegistrationStatusTypes?regYear=' + year).pipe(shareReplay(1));
  }

  getStabilizedEtpa(year) {
    return this.httpClient.get(this.baseurl + '/421aTypes?regYear=' + year).pipe(shareReplay(1));
  }

  getTempExemptStatus(year) {
    return this.httpClient.get(this.baseurl + '/ApartmentExemptTypes?regYear=' + year + '&exemptType=Temporarily').pipe(shareReplay(1));
  }

  getPermExemptStatus(year) {
    return this.httpClient.get(this.baseurl + '/ApartmentExemptTypes?regYear=' + year + '&exemptType=Permanently').pipe(shareReplay(1));
  }
}
